
export default {
  props: {
    errors: {
      type: Object
    }
  }
}
